import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/issuefield';

class ExtraFieldService {
    // extra fields
    getExtraFields(onlyActive) {
        if (onlyActive) {
            return axioscommon.get(API_URL, { headers: authHeader() });
        }
        return axioscommon.get(API_URL + '/getAll', { headers: authHeader() });
    }
    existReportable() {
        return axioscommon.get(API_URL + '/reportableExists', { headers: authHeader() });
    }
    getInitial() {
        return axioscommon.get(API_URL + '/getInitial', { headers: authHeader() });
    }
    saveExtraField(data) {
        return axioscommon.post(API_URL + '/', data, { headers: authHeader() });
    }
    updateExtraField(data) {
        return axioscommon.put(API_URL + '/', data, { headers: authHeader() });
    }
    // extra fields Options
    setOptionExtraField(id, data) {
        return axioscommon.put(API_URL + '/' + id, data, { headers: authHeader() });
    }
    removeOptionExtraField(id, data) {
        return axioscommon.put(API_URL + '/remove/' + id, data, { headers: authHeader() });
    }

    // issue related extrafields.
    getIssueExtraFieldVals(id) {
        return axioscommon.get(API_URL + 'value/' + id, { headers: authHeader() });
    }
    addValueToMultival(id, issueId, data) {
        return axioscommon.put(API_URL + 'value/' + id + '/' + issueId, data, { headers: authHeader() });
    }
    saveExtraFieldValue(issueId, data) {
        return axioscommon.post(API_URL + 'value/' + issueId, data, { headers: authHeader() });
    }
    getReportableIssueExtraFieldVals(id) {
        return axioscommon.get(API_URL + 'value/report/' + id, { headers: authHeader() });
    }

}

export default new ExtraFieldService();
